import "./index.css";

import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
 import IconProvider from "../IconProvider";
 import { ARROW_DOWN_BOLD , ic_circle_close} from "../../../assets/index";

import { CSSTransition } from 'react-transition-group';
import Typography from "../Typography";
import uuid from 'uuid-random';


const DropDown = ({ IconComponents, handleIsOpen, IsItemSelected = null, closeIcon, noArrowIcon = false, ItemsList, checkSelected = "hybrid", titleOnClick, clearOnClick, clearText, data, placement, text, badgeText, title, style, className, ref, onClick, size, icon, isSelected, isRequired, requiredText, textStyle } ) => {
    const [isOpen, setIsOpen] = useState(false);

    const [elmId, setElmId] = useState(`"elmDrop${uuid()}`);
    const [mapZindex, setMapZindex] = useState(0);

    //  useEffect(() => {
    //      setTimeout(() => {
    //         try {
    //               const element = document.getElementById('googlemapUniqeId');
    //               setMapZindex(element.style.zIndex)
    //         } catch (error) {
    //         }
    //      }, 1000);
    //     }, []);
    

    const dropdownNode  = useClickOutside(() => {
        setIsOpen(false);
    })

    const getParentWidth = React.useCallback(() => {

        let elm = document.getElementById(elmId)
        var box = elm.getBoundingClientRect();

        return box.width
        
      }, [elmId ]);

    useEffect(() => {

   try {
         if (handleIsOpen) {
             handleIsOpen(isOpen)
         }
 
 
   } catch (error) {
    
   }
    }, [isOpen]);


    const openEditCustomer = React.useCallback(() => {



        if(placement == "topStart"){
            let elm = document.getElementById(elmId)
   
            var body = document.body,
            html = document.documentElement;

            var height = Math.max( body.scrollHeight, body.offsetHeight, 
                                html.clientHeight, html.scrollHeight, html.offsetHeight );


            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var bottom  = height -  box.y
            var left = box.left 

            console.log("dwvefewsdxs ",body.clientHeight , box.y)

 
            return {bottom: `${Math.round(bottom)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

        }else if(placement == "topEnd"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top 
            var left = box.left + scrollLeft - clientLeft;
 
 
            return  {top: `${Math.round(top)}px`, right : `${Math.round(clientRight)}px`};

         
        }else if(placement == "bottomStart"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top +  box.height + 10;
            var left = box.left + scrollLeft - clientLeft;
 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
       
        }else if(placement == "bottomEnd"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top +  box.height + 10;
            var left = box.left + scrollLeft - clientLeft;
 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
        }else{
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top  
            var left = box.left 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

        }


        
      }, [elmId , placement]);

  
 
    //    useEffect(() => { 
    
        
    //     if(mapZindex != 0){
      
    //  try {
    //         if (isOpen) {
    //             const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = String(Number(mapZindex) - 1);
    //          } else {
    //        const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = mapZindex;
    //          }
    //      } catch (error) {
    //      }
    // }
        
    //      }, [isOpen]);

    // const openEditCustomer = React.useCallback(() => {


    //     if(placement == "topStart"){
    //         let elm = document.getElementById(elmId)
   
    //         var body = document.body,
    //         html = document.documentElement;

    //         var height = Math.max( body.scrollHeight, body.offsetHeight, 
    //                             html.clientHeight, html.scrollHeight, html.offsetHeight );


    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var bottom  = height -  box.y
    //         var left = box.left 

    //         console.log("dwvefewsdxs ",body.clientHeight , box.y)

 
    //         return {bottom: `${Math.round(bottom)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

    //     }else if(placement == "topEnd"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top 
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return  {top: `${Math.round(top)}px`, right : `${Math.round(clientRight)}px`};

         
    //     }else if(placement == "bottomStart"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top +  box.height + 10;
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
       
    //     }else if(placement == "bottomEnd"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top +  box.height + 10;
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
    //     }else{
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top  
    //         var left = box.left 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

    //     }


        
    //   }, [elmId , placement]);

  
 
    //    useEffect(() => { 
    
        
    //     if(mapZindex != 0){
      
    //  try {
    //         if (isOpen) {
    //             const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = String(Number(mapZindex) - 1);
    //          } else {
    //        const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = mapZindex;
    //          }
    //      } catch (error) {
    //      }
    // }
        
    //      }, [isOpen]);

    return (
        <>
           <div id={elmId} onClick={(e) => { setIsOpen(!isOpen); titleOnClick && titleOnClick() }} className={clsx(styles[`${size}`], isSelected && styles[`${size}selected`], className && className)}
            style={style ? style : {}} >

            {(IconComponents) && IconComponents}

            {(icon) && <IconProvider Icon={icon} size="16" />}
            {(text) && <span className={clsx(styles.title , textStyle && textStyle )} >
              { (closeIcon && isSelected) && <IconProvider Icon={ic_circle_close} size="14" onClick={(e) => {
                  e.stopPropagation();
                  clearOnClick && clearOnClick()
                  // setCurrentValue(null);
                  // onChange(null)
                }} />}
                 {text}
                {(isRequired && !isSelected) && <span className={styles.isRequired}> * </span>}
                {(badgeText) && <span className={styles.isRequired}> {badgeText} </span>}

            </span>}


            {(data && data.length > 0 && !noArrowIcon ) && <IconProvider Icon={ARROW_DOWN_BOLD} size="12" style={{ width: "10px", height: "10px" }} />}

        </div>

          { (isOpen && (data && data.length > 0)) && <CSSTransition
                in={isOpen && (data && data.length > 0)}
                timeout={500}
                classNames="dropdown-animation"
                unmountOnExit
                onEnter={() => setIsOpen(true)}
                onExited={() => setIsOpen(false)}
                style={openEditCustomer() ?  {...openEditCustomer() , minWidth:`${getParentWidth()- 32}px`} :{}}

            >
                <div ref={dropdownNode}  className={clsx(styles.dropdownBox, styles[placement])}  onClick={() => { setIsOpen(!isOpen)  }} >



                   {ItemsList ? ItemsList :  <div className={styles.itemsConatiner} >
                        {data.map((serv) => {
                            // return <div onClick={() => { onClick && onClick(serv) }} className={clsx((serv.title ? serv.title : serv) == text && styles.selectedDropItem)}>
                            return <div onClick={() => { onClick && onClick(serv) ; setIsOpen(false); }} className={clsx(( IsItemSelected ? IsItemSelected(serv)  : ( checkSelected == "hybrid" ? text?.includes((serv.title ? serv.title : serv)) : text == (serv.title ? serv.title : serv))) && styles.selectedDropItem)}>

                                {serv.icon && <img src={serv.icon} />}
                                {serv.title ? serv.title : serv}

                            </div>
                        })}
                    </div>}



                    {(clearText && isSelected) && <div style={{ borderTop: "1px solid #F4F4F7", padding: "16px 0 8px", width: "100%" }} onClick={() => { clearOnClick && clearOnClick() }} >
                        <Typography weight="Body_Middle_Medium" text={clearText} />
                    </div>}

                </div>
            </CSSTransition>}
        </>
     

    );
};

export default DropDown;



const useClickOutside = (handler) => {
    const domNode = useRef();
    useEffect(() => {
       try {
         const eventHandler = (event) => {
             if (!domNode?.current?.contains(event.target)) {
                 handler();
             }
             // uncomment this for dropdown close on menu click
             // handler();
         }
         document.addEventListener("mousedown", eventHandler);
         return () => {
             document.removeEventListener('mousedown', eventHandler);
         }
       } catch (error) {
        
       }
    });
    return domNode;
}